import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ListMediatipsComponent } from './list-mediatips/list-mediatips.component';

import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';

import { FormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MediatipStateModule } from './mediatip-state.module';
import {ContextMenuModule} from 'primeng/contextmenu';
import { TreeTableModule } from 'primeng/treetable';
import {PanelModule} from 'primeng/panel';
import { NgStringPipesModule } from 'ngx-pipes';
import { ToolbarModule } from 'primeng/toolbar';
import {ProgressSpinnerModule} from 'primeng/progressspinner';

import { DatePickerModule } from 'primeng/datepicker';

import {MessageModule} from 'primeng/message';
import { NotificationsModule } from '@app/+notifications/notifications.module';
import { PaginatorModule } from 'primeng/paginator';
import { RxPush } from '@rx-angular/template/push';

import { MediatipsRoutingModule } from './mediatips.routing.module';
import { MediatippsEditDialogComponent } from './dialogs/mediatippsEditDialog/mediatippsEditDialog.component';

import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputGroupModule } from 'primeng/inputgroup';
import { TextareaModule } from 'primeng/textarea';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { BadgeModule } from 'primeng/badge';
import { ButtonGroupModule } from 'primeng/buttongroup';




@NgModule({
    declarations: [ListMediatipsComponent, MediatippsEditDialogComponent],
    imports: [ContextMenuModule, ToolbarModule, ProgressSpinnerModule,  CommonModule, PanelModule, NgStringPipesModule, TreeTableModule, MediatipStateModule,
        SelectModule, InputTextModule, FormsModule, ConfirmDialogModule, DialogModule,
        PaginatorModule, MediatipsRoutingModule, TextareaModule,
        InputGroupAddonModule, InputGroupModule,
        ToastModule, TooltipModule, MessageModule,
        ButtonGroupModule,
        CommonModule, MatListModule, MatButtonModule, MatIconModule, TableModule, CheckboxModule, ButtonModule, DatePickerModule, NotificationsModule,
        RxPush,
           OverlayBadgeModule,
                BadgeModule,
    ],
    providers: [ConfirmationService, DialogService]
})
export class MediatipsModule { }
